import { Box, Typography } from '@mui/material';

const NotFound = () => {
  return (
    <Box sx={{ width: '100%', height: '100svh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <Box sx={{ width: 35, height: 35, color: '#475569' }}>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" className="humbleicons hi-ship"><path xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 17l.756.378a3 3 0 002.523.074l1.04-.446a3 3 0 012.363 0l1.04.446a3 3 0 002.523-.074l.413-.207a3 3 0 012.684 0l.547.273a3 3 0 002.29.163L21 17M5 14.5L4 10h4m10 4.5l2.5-4.5h-8.245H13.5m0 0l-.721-3H8v3m5.5 0H8m3 3h.1M10 4.5l-.2-.2a2 2 0 00-1.899-.525l-.336.084a2 2 0 01-1.118-.043L5.5 3.5" /></svg>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
        <Typography sx={{ fontSize: 30, color: '#475569', textAlign: 'center', fontFamily: 'Poppins', fontWeight: 600 }}>404</Typography>
        <Box sx={{ width: 2, height: 20, background: '#475569' }} />
        <Typography sx={{ fontSize: 20, color: '#475569', textAlign: 'center', fontFamily: 'Poppins', fontWeight: 600 }}>Page Not Found</Typography>
      </Box>
    </Box>
  )
}

export default NotFound